// Entry point for the build script in your package.json
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '@hotwired/turbo-rails';
import './controllers';
import './timezone_detector';
import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();
